import React from 'react';

const SearchIcon = props => (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
         fill={props.fill ? props.fill : 'currentColor'}
         stroke={props.stroke ? props.stroke : 'currentColor'} strokeWidth="0" strokeLinecap="round"
         strokeLinejoin="round"
    >
        <path
            d="M15.7549 14.2549H14.9649L14.6849 13.9849C15.6649 12.8449 16.2549 11.3649 16.2549 9.75488C16.2549 6.16488 13.3449 3.25488 9.75488 3.25488C6.16488 3.25488 3.25488 6.16488 3.25488 9.75488C3.25488 13.3449 6.16488 16.2549 9.75488 16.2549C11.3649 16.2549 12.8449 15.6649 13.9849 14.6849L14.2549 14.9649V15.7549L19.2549 20.7449L20.7449 19.2549L15.7549 14.2549ZM9.75488 14.2549C7.26488 14.2549 5.25488 12.2449 5.25488 9.75488C5.25488 7.26488 7.26488 5.25488 9.75488 5.25488C12.2449 5.25488 14.2549 7.26488 14.2549 9.75488C14.2549 12.2449 12.2449 14.2549 9.75488 14.2549Z"/>
    </svg>
);

export default SearchIcon;



// WEBPACK FOOTER //
// ./src/assets/icons/SearchIcon.jsx